var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74955 4C3.16352 4 3.4991 4.33579 3.4991 4.75L3.50417 12.0648C3.66596 12.0225 3.83573 12 4.01076 12H20.0012C21.1051 12 22 12.8954 22 14L21.988 21.2499C21.988 21.6642 21.6525 21.9999 21.2385 21.9999C20.8245 21.9999 20.4889 21.6642 20.4889 21.2499L20.5009 16H3.5069L3.4991 21.25C3.4991 21.6642 3.16352 22 2.74955 22C2.33559 22 2 21.6642 2 21.25V4.75C2 4.33579 2.33559 4 2.74955 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBed);
export default __webpack_public_path__ + "static/media/hospital-bed.f47a5480cbfa482ffdd0a01e5b3039e6.svg";
export { ForwardRef as ReactComponent };